import { useState, useEffect } from 'react'

/**
 * Returns true when page has scrolled past `threshold` pixels.
 * Throttled to ~60fps with requestAnimationFrame to avoid layout thrashing.
 */
export function useScrolled(threshold = 4): boolean {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    let ticking = false

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setScrolled(window.scrollY > threshold)
          ticking = false
        })
        ticking = true
      }
    }

    // Check initial state
    setScrolled(window.scrollY > threshold)

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [threshold])

  return scrolled
}